<template>
  <!--签署回调-->
  <div class="sign-callback">
    <!--筛选-->
    <el-row type="flex" class="row">
      <el-col :span="7"></el-col>
      <el-col :span="4">
        <el-select
          v-model="selectOption"
          placeholder="请选择"
          size="small"
          style="width: 150px"
        >
          <el-option label="签署编号" value="apply_no" />
          <el-option label="类型" value="ctype" />
          <el-option label="回调状态" value="dealStatus" />
        </el-select>
      </el-col>
      <el-col :span="4">
        <template v-if="selectOption === 'apply_no'">
          <el-input
            v-model="param.applyNo"
            size="small"
            placeholder="查询内容"
            style="width: 150px"
          />
        </template>
        <template v-else-if="selectOption === 'ctype'">
          <el-select
            v-model="param.ctype"
            value="-1"
            placeholder="请选择"
            size="small"
            style="width: 150px"
          >
            <el-option label="全部" :value="null" />
            <el-option label="签署" :value="0" />
            <el-option label="保全" :value="1" />
          </el-select>
        </template>
        <template v-else-if="selectOption === 'dealStatus'">
          <el-select
            v-model="param.dealStatus"
            value="-1"
            placeholder="请选择"
            size="small"
            style="width: 150px"
          >
            <el-option label="全部" :value="null" />
            <el-option label="待发送" :value="1" />
            <el-option label="正在发送" :value="2" />
            <el-option label="成功" :value="3" />
            <el-option label="失败" :value="4" />
          </el-select>
        </template>
      </el-col>
      <el-col :span="6">
        <el-date-picker
          v-model="selectDateArr"
          value-format="yyyy-MM-dd"
          :default-time="['00:00:00', '23:59:59']"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
          style="width: 100%"
        />
      </el-col>
      <el-col :span="3" class="text-right">
        <el-row type="flex">
          <el-col :span="12">
            <el-button @click="getCallBackList" size="small">查询</el-button>
          </el-col>
          <el-col :span="12">
            <el-button @click="rest" size="small">重置</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <!--列表-->
    <el-table
      :data="dataList"
      v-loading="loading"
      class="data-list"
      tooltip-effect="dark"
      :header-cell-style="{
        background: '#f9f9f9',
        color: '#333333',
        fontWeight: '500',
      }"
    >
      <el-table-column label="签署编号" prop="applyNo" show-overflow-tooltip />
      <el-table-column label="签署流水号" prop="signNo" show-overflow-tooltip />
      <el-table-column label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.ctype === 1">保全</span>
          <span v-else>签署</span>
        </template>
      </el-table-column>
      <el-table-column label="回调状态">
        <template slot-scope="scope">
          <span v-if="scope.row.dealStatus === 1">待发送</span>
          <span v-else-if="scope.row.dealStatus === 2">正在发送</span>
          <span v-else-if="scope.row.dealStatus === 3">成功</span>
          <span v-else-if="scope.row.dealStatus === 4">失败</span>
        </template>
      </el-table-column>
      <el-table-column label="失败次数" prop="failTimes" />
      <el-table-column
        label="失败原因"
        prop="failError"
        show-overflow-tooltip
        width="150"
      />
      <el-table-column
        label="更新时间"
        prop="updateTime"
        show-overflow-tooltip
        width="150"
      />
      <el-table-column label="操作" width="80">
        <template slot-scope="scope">
          <span
            @click="resendCallBack(scope.row.callBackId)"
            v-if="scope.row.dealStatus === 3 || scope.row.dealStatus === 4"
            class="color-success resend-callback options-sty"
            >重发</span
          >
        </template>
      </el-table-column>
      <no-data text="暂无数据" slot="empty" />
    </el-table>

    <!--分页-->
    <el-row class="pageation row">
      <el-col :span="6">
        <div style="height: 20px"><!--占位--></div>
      </el-col>
      <el-col :span="18" class="page-flex-end">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="param.itemPage"
          :page-sizes="[10, 20, 50, 100]"
          :pager-count="5"
          :page-size="param.pageSize"
          layout="sizes, prev, pager, next, total"
          :total="param.total"
        />
        <el-go
          :page-size="param.pageSize"
          :total="param.total"
          @current-change="handleCurrentChange"
        ></el-go>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  postCallBackPage,
  postResendCallBack
} from "../../assets/js/http-serve/http-methods";
import ElGo from "../go/Go";
const paramInfo = {
  itemPage: 1,
  pageSize: 10,
  beginDate: null,
  endDate: null,
  applyNo: null,
  ctype: null,
  dealStatus: null
};

export default {
  components: { ElGo },
  data () {
    return {
      dataList: [],
      // 查询参数
      param: paramInfo,
      selectOption: "apply_no",
      selectDateArr: null,
      currentPage: 1,
      loading: false
    };
  },
  watch: {
    selectDateArr: {
      handler (val) {
        if (val && val.length === 2) {
          this.param.beginDate = val[0];
          this.param.endDate = val[1];
        } else {
          this.param.beginDate = this.param.endDate = null;
        }
      },
      deep: true
    },
    selectOption () {
      this.param.applyNo = "";
      this.param.ctype = null;
      this.param.dealStatus = null;
    }
  },
  beforeMount () {
    this.getCallBackList();
  },
  methods: {
    // 重发消息
    resendCallBack (id) {
      postResendCallBack(id)
        .then(data => {
          this.$confirm("更新发送状态成功", "系统提示", {
            confirmButtonText: "确定",
            type: "success"
          });
          this.getCallBackList();
        })
        .catch(err => {
          this.$alert("更新发送状态失败", "系统提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        });
    },
    // 重置
    rest () {
      this.selectOption = "apply_no";
      this.selectDateArr = null;
      this.param.applyNo = "";
      this.param.ctype = null;
      this.param.dealStatus = null;
      this.param.beginDate = null;
      this.param.endDate = null;
      this.getCallBackList();
    },
    // 获取签署列表
    getCallBackList: function () {
      this.loading = true;
      postCallBackPage(this.param)
        .then(data => {
          this.param.itemPage = data.pageNum;
          this.param.pageSize = data.pageSize;
          this.param.total = data.total;
          this.$parent.badge = data.total;
          this.dataList = data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`);
      this.param.itemPage = 1;
      this.param.pageSize = val;
      this.getCallBackList();
    },
    handleCurrentChange (val) {
      // console.log(`当前页: ${val}`);
      this.param.itemPage = val;
      this.getCallBackList();
    }
  },
  name: "sign-callback"
};
</script>

<style lang="less" scoped>
.options-sty{
  color:#290202;
}
.pageation {
  padding: 30px 10px 20px 10px;
  border-top: 0;
}
.resend-callback {
  cursor: pointer;
}
.dialog-footer {
  padding-bottom: 20px;
  .btn {
    width: 30%;
  }
}
</style>



// WEBPACK FOOTER //
// components/ent-access/signCallback.vue